import axios from 'axios';

export default axios.create({
  //baseURL: process.env.REACT_APP_SQL_BASE_URL,
  headers: {
    "Access-Control-Allow-Origin": "*"},
  baseURL: 'https://server.ylight.xyz/',
});
